import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {EvidFunctionsService} from '@catmodules/models/evid-functions/services/evid-functions.service';
import {UIFormModule} from '@catuiform/ui-form.module';
import { EvidFunctionsComponent } from '@catmodules/models/evid-functions/components/evid-functions/evid-functions.component';
import {DataTableModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import { EvidDebugComponent } from './components/evid-debug/evid-debug.component';

const publicComponents = [
  EvidFunctionsComponent,
  EvidDebugComponent
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
  DataTableModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [EvidFunctionsService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class EvidFunctionModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/evid-functions/evid-function.module.ts